export default {
  login: '/user/login',
  logout: '/user/logout',
  register: '/user/register',
  resetPassword: '/user/forgotPassword',
  getProfile: '/user/authGetProfile',
  saveProfile: '/user/authUpdateProfile',
  getPets: '/pet/authList',
  getSpecies: '/pet/listSpecies',
  getRaces: '/pet/listRaces',
  createPet: '/pet/authCreate',
  updatePet: '/pet/authUpdate',
  deletePet: '/pet/authDelete',
  getVisitTypes: '/appointment/authListAppointmentTypes',
  getInstitutionsInRange: '/institution/listByRange',
  getUserCanBook: '/institution/authGetUserCanBook',
  getAvailableVisitTimes: '/institution/listAvailableAppointmentTimes',
  bookAppointment: '/appointment/authCreatePlanned',
}
